import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Home from './Home';

// by default we only pull in the user state - expand as needed
const mapStateToProps = (state = {}) => ({
  ...state.users,
  ...state.modelPages,
});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(Home));
